import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "../../styles/Component/Chat/MessageBubble.css";

const MessageBubble = ({ message }) => {
  const isOutbound = message.direction === "outbound";

  return (
    <div className={`message-bubble-wrapper ${isOutbound ? "outbound" : "inbound"}`}>
      {isOutbound && (
        <span className="message-sender-label">
          {message.sender === "ai" ? "AI" : "System"}
        </span>
      )}
      <div className={`message-bubble ${isOutbound ? "message-outbound" : "message-inbound"}`}>
        <p className="message-body">{message.body}</p>
      </div>
      <span className="message-timestamp">
        {moment(message.createdAt).format("MMM D, YYYY h:mm A")}
      </span>
    </div>
  );
};

MessageBubble.propTypes = {
  message: PropTypes.shape({
    body: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    sender: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
};

export default MessageBubble;
